// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3J_SU","popup":"style_popup__31GPH","pipette":"style_pipette__1JLtN","icon":"style_icon__2Rw1q"};